/**
 *  call this component when close case and not order case
 */
import React, { FC, useEffect, useState } from "react"
import { useParams, useSearchParams } from "react-router-dom"
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContentText,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  FormHelperText,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Switch,
} from "@mui/material"
import { caseManagement } from "@/gluelayer"
import WorkflowDropdown from "./WorkflowDropdown"

import { useAppDispatch, useAppSelector } from "../../../../core/app/hooks"
import { updateCaseById } from "../../../../core/app/slices/case/caseThunkApi"
import {
  unlockCaseApi,
  uploadCaseZips,
} from "../../../../core/app/slices/clinical/clinicalThunkApi"
import { RootState } from "../../../../core/app/store"
import DialogBox from "@/modules/Clinical/components/DialogBox/dialogBox"
import { UButton } from "@/components/index"
import { Checkbox } from "@mui/material"
import { setShouldCloseTab } from "@/UDTreat/udTreatSlice"
import { useMyNavigation } from "@/hooks/useMyNavigation"
import { safeCloseWindow } from "@/core/app/CloseTabContext"
interface assignTyp {
  isActive: boolean
  planList: { txName: string; index: number }[]
  uploadReportPdf: () => void
  currentPlan: {
    txName: string
    index: 2 | 1
  }
  showPrompt: boolean | (() => void)
  confirmNavigation: boolean | (() => void)
  uploadAllData
  deletePlanFunction: (plan: number) => boolean
  // setCloseClick: (val: boolean) => void
  isEdit: boolean
  isFull: boolean
  setIsShowAssign
}
const AssignPopup: FC<assignTyp> = ({
  isActive,
  planList,
  uploadReportPdf,
  currentPlan,
  showPrompt,
  confirmNavigation,
  uploadAllData,
  deletePlanFunction,
  // setCloseClick,
  setIsShowAssign,
  isEdit,
  isFull
}) => {
  const { caseList } = useAppSelector((state: RootState) => state.caseService)

  const {
    userService: {
      user: { user_id },
      workflow: {
        showWorkflow
      }
    },
    doctorService: { doctorList },
    clinicalService: { treatmentList },
  } = useAppSelector((state: RootState) => state)

    const [doctors, setdoctor] = useState<Array<{name: string, id: number}>>([])
  const [staffs, setstaffs] = useState<Array<{name: string, id: number}>>([])
  const [assigner, setassigner] = useState<number | null>(null)
  const [isAssign, setisAssign] = useState(false)
  const [plan, setplan] = useState<number>(1)
  const [phaseId, setPhaseId] = useState<number | null>(null)
  
  const handleWorkflowChange = (value: number) => {
    setPhaseId(value)
  }
  const dispatch = useAppDispatch()
  const { caseId, patientId } = useParams()
  const [searchParams, setSearchParams] = useSearchParams()
  const [showDeleteWarning, setShowDeleteWarning] = useState(false)
  // const [showAssign, setShowAssign] = useState(true)
  const [needUpload, setNeedUpload] = useState(false)
  const navigate = useMyNavigation()
  const from = searchParams.get("from")
  const [validationMode, setValidationMode] = useState<boolean>(false)
  
  useEffect(()=>{
    const phaseForCurrentCase = caseList.find(caseObj=>caseObj.id==Number(caseId))?.phase;
    if(phaseForCurrentCase) {
      setPhaseId(phaseForCurrentCase)
    }
  },[caseList])

  useEffect(() => {
    const d = [],
      s = []
    doctorList.map(({ category, first_name, last_name, id }) => {
      if (category === "Doctors") {
        d.push({ name: first_name + " " + last_name, id: id })
      } else {
        s.push({ name: first_name + " " + last_name, id: id })
      }
    })
    setdoctor(d)
    setstaffs(s)
  }, [doctorList])

  const onClickSaveCase = () => {
    if(!isEdit) {
      safeCloseWindow()
      return
    }
    dispatch(setShouldCloseTab(true))
    let path = "/patients"
    if (from === "bundle" || location.hash === "#uassist") {
      console.log("location :", location.hash)
      path = "/patients"
    }
    navigate(path)
  }

  /**
   * post to BE when you assign order case to someone
   */
  const assignFun = () => {
    if(!assigner || (showWorkflow && !phaseId)){
      setValidationMode(true)
      return
    }
    if (isAssign && caseManagement.getTreatmentPlanList().length > 1){
      setNeedUpload(true)
      setShowDeleteWarning(true)
      // setShowAssign(false)
      return
    }
    let res = isAssign
      ? {
          assigned_to: assigner,
          case_disposition: "PLACE_ORDER",
        }
      : {
          assigned_to: assigner,
        }
    if(showWorkflow){
      res.phase = phaseId
    }
    // setShowAssign(false)
    if (!isEdit && needUpload){
      uploadAllData({
        ...res,
        callback: () => {
          dispatch(unlockCaseApi({ patientId, caseId })).then(() => {
            onClickSaveCase()
          })
        },
      })
    } else {
      dispatch(
        updateCaseById({
          patientId,
          caseId,
          payload: {
            ...res
          },
        }),
      ).then(() => {
        onClickSaveCase()
      })
    }
  }

  useEffect(() => {
    if (treatmentList && treatmentList.length && treatmentList[0].assigned_to)
      setassigner(Number(treatmentList[0].assigned_to))
    else setassigner(Number(user_id))
  }, [user_id, treatmentList])

  useEffect(() => {
    if (isAssign) setplan(currentPlan?.index || 1)
  }, [planList, isAssign])

  // useEffect(() => {
  //   if (showPrompt && isActive && !showDeleteWarning) {
  //     setShowAssign(true)
  //   }
  // }, [showPrompt, isActive])

  return (
    <>
      <Dialog open={showPrompt && isActive}>
        <Paper sx={{ width: 444, height: "auto" }}>
          {/* <DialogTitle id="alert-dialog-title">
            {"Save case"}
          </DialogTitle>
           */}
          <DialogContent>
            <DialogContentText sx={{ padding: "15px 0 8px", color:"rgba(0, 0, 0, 0.87)" }}>
              {"Assign to"}
            </DialogContentText>
          
            <Select
              value={assigner}
              sx={{
                width: "100%",
              }}
              onChange={(e) => {
                setassigner(e.target.value)
              }}
              error={!!(validationMode && !assigner)}
            >
              <FormHelperText
                sx={{
                  width: "100%",
                  padding: "0 16px",
                }}
              >
                Doctors
              </FormHelperText>
              {doctors.map(({ name, id }) => (
                <MenuItem key={id} value={id} sx={{ paddingTop: 1, fontStyle: "normal !important", }}>
                  {name}
                </MenuItem>
              ))}
              <Divider></Divider>
              <FormHelperText
                sx={{
                  width: "100%",
                  padding: "0 16px",
                }}
              >
                Staffs
              </FormHelperText>
              {staffs.map(({ name, id }) => (
                <MenuItem key={id} value={id}>
                  {name}
                </MenuItem>
              ))}
            </Select>
            {showWorkflow ? <WorkflowDropdown 
              workflowId={phaseId}
              onChange={handleWorkflowChange}
              validationMode={validationMode}
            /> : <></>}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(e) => {
                setIsShowAssign(false)
                dispatch(setShouldCloseTab(false))
              }}
              sx={{
                textTransform: "uppercase",
                color: "rgba(0, 0, 0, 0.87)",
              }}
            >
              CANCEL
            </Button>
            <Button
              onClick={() => {
                // setShowAssign(false)
                setIsShowAssign(false)
                assignFun()
                // ToDo: to be rewritten with actual logic ?
              }}
              autoFocus
              sx={{
                textTransform: "uppercase",
              }}
              size="medium"
              color="primary"
              variant="contained"
            >
              Save
            </Button>
          </DialogActions>
        </Paper>
      </Dialog>
      <DialogBox open={showDeleteWarning} title="Warning" 
        content={<>{`You have selected to proceed with 'Plan ${plan}' and 'Plan ${plan === 1 ? 2 : 1}' will be deleted. Are you sure you want to proceed with this choice?`}</>} 
        actions=
        {<>
          <UButton
            onClickHandler={ () => {
              setIsShowAssign(true)
              setShowDeleteWarning(false)
              // setShowAssign(true)
              setNeedUpload(false)
            }}
            variant={"text"}
            btnText={("Cancel")}
          />
          <UButton
            onClickHandler={ () => {  
              setIsShowAssign(false) 
              setNeedUpload(true) 
              const isdel = deletePlanFunction(plan === 1 ? 2 : 1)
              if(isdel){
                setShowDeleteWarning(false)
                assignFun()
              }
            }}
            variant={"text"}
            btnText={("OK")}
          />
        </>
        }
        >
      </DialogBox>
    </>
    
  )
}
export default AssignPopup
